'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  app: {
    title: 'Calendrier du Cégep Saint-Laurent',
    description: 'Un calendrier propulsé par Caligram.',
    domain: 'calendrier.cegepsl.qc.ca',
    meta: {
      charSet: 'utf-8',
      property: {
        'og:site_name': 'Calendrier du Cégep Saint-Laurent',
        'og:image': 'http://api.caligram.com/logo.png',
        'og:locale': 'fr_CA',
        'og:title': 'Calendrier du Cégep Saint-Laurent',
        'og:description': 'Un calendrier propulsé par Caligram',
        'twitter:card': 'summary',
        'twitter:site': '@coopterritoires',
        'twitter:creator': '@coopterritoires',
        'twitter:title': 'Caligram',
        'twitter:description': 'Un calendrier propulsé par Caligram.',
        'twitter:image': 'http://api.caligram.com/logo.png',
        'twitter:image:width': '232',
        'twitter:image:height': '58'
      }
    },
    googleMaps: {
      apiKey: 'AIzaSyCy97Z2sug3TMpl_703GYxQUshmpL467A0'
    },
    googleTagManager: {
      id: 'GTM-M8JTMDB'
    },
    entities: {
      audiences: {
        initialData: null,
        inFilters: true,
        menu: null
      },
      organizations: {
        inFilters: true
      },
      regions: {
        inFilters: true,
        limit: 5
      },
      tags: {
        inFilters: false,
        menuOrder: 'label'
      },
      types: {
        inFilters: true,
        menuOrder: 'label'
      },
      venues: {
        inFilters: true,
        limit: 5
      }
    },
    filtersEntitiesOrder: 'audiences organizations regions tags types venues'.split(' '),
    featured: {
      limit: 3
    },
    show: {
      featured: true,
      recurrencesButton: true
    },
    map: {
      centerLat: 45.512309,
      centerLng: -73.671953,
      initialZoom: 18
    },
    externalScripts: []
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 54
// module chunks = 0